import React__default from 'react';
import st from '../../node_modules/styled-components/dist/styled-components.esm.mjs';
import { GridContainer, Column } from '@vp/swan';
import { ProductOptions } from './ProductOptions.mjs';
import { FooterPrice } from '../FooterPrice.mjs';

const StickyRowWrapper = st.div({
    marginBottom: 0,
    marginTop: 0,
    paddingBottom: 0,
    paddingTop: 0,
    display: "block",
    position: "sticky",
    bottom: 0,
    zIndex: 10,
    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.10)",
});
const StickyRowSiblingWrapper = st.div({
    display: "flex",
    flexWrap: "wrap",
    marginBottom: 0,
    marginTop: 0,
    paddingLeft: 0,
    position: "relative",
    zIndex: 1,
});
const ConfiguratorLayout = ({ responseButtons: ResponseButtons, ...rest }) => {
    return (React__default.createElement(GridContainer, { gutter: "tight" },
        React__default.createElement(StickyRowSiblingWrapper, null,
            React__default.createElement(Column, { span: 12 },
                React__default.createElement(ProductOptions, { ...rest }))),
        React__default.createElement(StickyRowWrapper, null,
            React__default.createElement(Column, { span: 12, bgc: "standard", paddingTop: "3", mb: 0, pb: "3", paddingX: "4" },
                React__default.createElement(FooterPrice, null),
                React__default.createElement(ResponseButtons, null)))));
};

export { ConfiguratorLayout };
//# sourceMappingURL=ConfiguratorLayout.mjs.map
